import { FitnessTrackerGraphics } from 'app/components/berichte/fitnesstracker/FitnessTrackerGraphics';
import { AgenturModel } from 'app/models/agentur.model';
import { BranchenplanungPosDef } from 'app/models/branchenplanung/bp.pos.def';
import { JpgAmisNowQualiContent, JpgAmisNowVorbereitungContent, JpgHandlungsempfehlungen } from 'app/components/documents/jpg/JpgThemenContent';
import colors from 'assets/scss/colors.module.scss';
import { IJpgThemaDef, MissingDataView } from 'app/stores/ui/jpg.themen.ui.store';



let jpgThemen2025Def: IJpgThemaDef[] = [
    {
        group: 'ADZ',
        keyThema: 'gup',
        themaShort: 'GUP',
        thema: 'Mein Google Unternehmensprofil',
        byLine: 'Sichtbar sein DigitalPersönlich',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="sichtbarSein" onClose={() => { }} homeAlone={true} />,
        background: colors.green,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'smt',
        themaShort: 'SMT',
        thema: 'Einsatz der Social Media Toolbox',
        byLine: 'Sichtbar sein DigitalPersönlich PLUS',
        // dataComponent: <MissingDataView />,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['LinkedIn', 'XING']} />,
        missingDef: 'waiting for FT Data',
        background: colors.green,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'amis',
        themaShort: 'AMIS.NOW',
        thema: 'AMIS.NOW Aufgaben',
        byLine: 'Jeden Kontakt Nutzen',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="amis" onClose={() => { }} homeAlone={true} />,
        background: colors.turquoise,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'sts',
        themaShort: 'S2S',
        thema: 'Service-to-Sale',
        byLine: 'Jeden Kontakt Nutzen PLUS',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="sts" onClose={() => {}} homeAlone={true} />,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Vertriebschancen im Agenturteam nutzen', 'Anmeldung Schulung Agenturteam']} />,
        background: colors.turquoise,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'akumaPlaner',
        themaShort: 'AKUMA',
        thema: 'AKUMA Planer und Aktionen',
        byLine: 'Jeden Kunden kontaktieren',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="akumaPlaner" onClose={() => { }} homeAlone={true} />,
        background: colors.yellow,
    },
    {
        group: 'ADZ',
        keyThema: 'akumaPrime',
        themaShort: 'AKUMA Prime',
        thema: 'AKUMA Prime',
        byLine: 'Jeden Kunden kontaktieren PLUS',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="akumaPrime" onClose={() => { }} homeAlone={true} />,
        background: colors.yellow,
    },
    {
        group: 'ADZ',
        keyThema: 'maz',
        themaShort: 'MAZ',
        thema: 'Meine Allianz',
        byLine: 'Immer da sein',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="maz" onClose={() => { }} homeAlone={true} />,
        background: colors.primary,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'mazPlus',
        themaShort: 'KVM',
        thema: 'VU Inbound (KVM)',
        byLine: 'Immer da sein Plus',
        dataComponent: (agt: AgenturModel, year: number) => <FitnessTrackerGraphics agtId={agt.agtId} view="vuinbound" onClose={() => {}} homeAlone={true} />,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Einrichtung Inbound', 'Förderung Erreichbarkeit']} />,
        background: colors.primary,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'leadnow',
        themaShort: 'Empfehlungen',
        thema: 'Empfehlungen',
        byLine: 'Neue Kunden finden',
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Empfehlungsmanagement', 'Kundenzufriedenheit nutzen']} />,
        background: colors.richTurquoise,
        color: colors.white,
    },
    {
        group: 'ADZ',
        keyThema: 'leadnowPlus',
        themaShort: 'AMIS.NOW Leads',
        thema: 'AMIS.NOW Leads',
        byLine: 'Neue Kunden finden Plus',
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Prüfung AMIS.NOW Leads fähig', 'Einrichtung AMIS.NOW Leads']} />,
        background: colors.richTurquoise,
        color: colors.white,
    },
    {
        group: 'AMIS.NOW',
        keyThema: 'amisnowVor',
        themaShort: 'AMIS.NOW',
        thema: 'Vorbereitung',
        byLine: 'AMIS.NOW',
        textComponent: <JpgAmisNowVorbereitungContent />,
        background: colors.purple,
        color: colors.white,
    },
    {
        group: 'AMIS.NOW',
        keyThema: 'amisnowQuali',
        themaShort: 'AMIS.NOW',
        thema: 'Qualifizierung',
        byLine: 'AMIS.NOW',
        textComponent: <JpgAmisNowQualiContent />,
        background: colors.purple,
        color: colors.white,
    },
];

BranchenplanungPosDef.forEach((bpPosDef) => {
    jpgThemen2025Def.push({
        group: 'Branchenplanung',
        keyThema: bpPosDef.planKey,
        thema: bpPosDef.posText,
        themaShort: bpPosDef.posText,
        background: colors.softStone,
        bpKeys: [bpPosDef.planKey],
        // dataComponent: (agt: AgenturModel, year: number) => {
        // 	return (
        // 		<>
        // 			<div className="pad-1rem">
        // 				<AgtBranchenplanungEdit agt={agt} year={year} showErgebnisse={true} hightlightKey={bpPosDef.planKey} />
        // 				<AgtJpgBpEditButtons />
        // 			</div>
        // 			<AgtBranchenplanungEditModal agt={agt} year={year} showErgebnisse={true} />
        // 		</>
        // 	);
        // },
        textComponent: (
            <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Schwerpunktagentur setzen', 'Aktivitäten/Initiativen zur Produktionssteigerung', 'Aktivitäten/Initiativen zur fachlichen Qualifizierung']} />
        ),
    });
});

jpgThemen2025Def = jpgThemen2025Def.concat([
    {
        group: 'Kontakt',
        keyThema: 'agtauftritt',
        themaShort: 'Agentur',
        thema: 'Agenturauftritt',
        background: colors.richWater,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Außenwerbung', 'Möbelkonzept', 'Ausstattung']} />,
    },
    {
        group: 'Kontakt',
        keyThema: 'homepage',
        themaShort: 'Homepage',
        thema: 'Homepage',
        background: colors.richWater,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['SEA (Search Engine Advertising)', 'SEO (Search Engine Optimization)', 'Einbindung Module', 'Einbindung Email Signatur']} />,
    },
    {
        group: 'Beratung',
        keyThema: 'recht',
        themaShort: 'wEWE',
        thema: 'Recht und Gesetz',
        background: colors.softGrey,
        textComponent: (
            <JpgHandlungsempfehlungen
                handlungsEmpfehlungen={[
                    'Bedeutung und Notwendigkeit wEWE',
                    'Agenturprozesse zur wEWE, dEWE Einholung überprüfen',
                    'Überprüfung Kontaktdaten, Digi-ID',
                    'Berücksichtigung EU-DSGVO (Einholung dEWE)',
                    'IDD Erfüllung nachhalten'
                ]}
            />
        ),
    },
    {
        group: 'Beratung',
        keyThema: 'spezis',
        themaShort: 'Spezialisten',
        thema: 'Spezialisteneinsatz',
        background: colors.softGrey,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Berücksichtigung Agentur-Cluster', 'Verstärkte Nutzung DSE', 'Tarif- und Themenschulung']} />,
    },
    {
        group: 'Nachhaltigkeit',
        keyThema: 'bwl',
        themaShort: 'BWL',
        thema: 'Betriebswirtschaftliche Geamtsituation',
        background: colors.softLime,
        textComponent: (
            <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Überprüfung Ausgabensituation', 'Überprüfung Einnahmensituation', 'Neugeschäft', 'Geschäftsplan - Incentives - Vertriebsschwerpunkte']} />
        ),
    },
    {
        group: 'Nachhaltigkeit',
        keyThema: 'kundendaten',
        themaShort: 'NPS',
        thema: 'Kundendaten und NPS',
        background: colors.softLime,
        textComponent: (
            <JpgHandlungsempfehlungen
                handlungsEmpfehlungen={[
                    'Digital-ID',
                    'Ableitungen aus Kundenzufriedenheitsreport',
                    'Einholung der Gesellschafts wEWE',
                    'Bedarf Personalkapazität',
                    'Vorgehensweise Personalsuche Bürokraft und Zweitverkäufer',
                    'Personalführung, Coaching'
                ]}
            />
        ),
    },
    {
        group: 'Nachhaltigkeit',
        keyThema: 'personal',
        themaShort: 'Personal',
        thema: 'Agentur und Personal',
        background: colors.softLime,
        textComponent: <JpgHandlungsempfehlungen handlungsEmpfehlungen={['Bedarf Personalkapazität', 'Vorgehensweise Personalsuche Bürokraft und Zweitverkäufer', 'Personalführung & Coaching']} />,
    },
]);


export const JpgFocusThemenDef2025 = jpgThemen2025Def;